import React from "react";
import StoreLocatorHeaderWeb from "./storeLocatorHeaderWeb";
import StoreLocatorHeaderMob from "./storeLocatorHeaderMob";
import "./style.scss";

const StoreLocatorHeader = () => {
  return (
    <>
      <div className="storeLocatorHeaderWrapWeb">
        <StoreLocatorHeaderWeb />
      </div>
      <div className="storeLocatorHeaderWrapMob">
        <StoreLocatorHeaderMob />
      </div>
    </>
  );
};

export default StoreLocatorHeader;
